import moment from 'moment';

import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { shouldStatusExecute } from '../../reducers/utils/state-manager';
import {
  featureGatesForUsernameFlag,
  featureGatesStateForUsernameFlag,
} from '../feature-gate-selectors';

import { ProductTelemetryController } from '../../product-telemetry/product-telemetry-controller';

export const loadFeatureGate = (currentUser: AuthenticatedUser, gateName: string) =>
  createGenericDispatcher({
    name: 'LOAD_FEATURE_GATE',
    loadFunction: () => ProductTelemetryController.checkGate(currentUser, gateName),
    args: { gateName, currentUser },
    shouldExecute: (state: any) => {
      const featureGateState = featureGatesStateForUsernameFlag(
        state,
        currentUser.username,
        gateName,
      );
      const featureGate = featureGatesForUsernameFlag(state, currentUser.username, gateName);

      // If we have previously loaded this gate and the TTL has not yet passed, we won't reload
      if (featureGateState?.success) {
        return featureGate ? moment(featureGate.ttl).isSameOrBefore(moment()) : true;
      }

      return shouldStatusExecute(featureGateState);
    },
  });
